const browserAlertOn = ()=>{
    window.onbeforeunload = ()=> true
};

const browserAlertOff = ()=>{
    window.onbeforeunload = null;
};

export {browserAlertOn, browserAlertOff};